var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "b-loading",
        {
          attrs: { "is-full-page": true, "can-cancel": true },
          model: {
            value: _vm.isLoading,
            callback: function ($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading",
          },
        },
        [
          _c("b-icon", {
            attrs: {
              pack: "fas",
              icon: "sync-alt",
              size: "is-large",
              "custom-class": "fa-spin",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box pb-0" },
        [
          _c("h1", { staticClass: "subtitle is-4" }, [
            _vm._v("Mis certificados"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "title is-3" }, [
            _vm._v("Generar certificado"),
          ]),
          _vm._v(" "),
          _c(
            "b-steps",
            {
              attrs: { animated: true, "has-navigation": false },
              model: {
                value: _vm.step,
                callback: function ($$v) {
                  _vm.step = $$v
                },
                expression: "step",
              },
            },
            [
              _c("b-step-item", {
                attrs: { clickable: false, step: "1", label: "Inicio" },
              }),
              _vm._v(" "),
              _c("b-step-item", {
                attrs: {
                  clickable: false,
                  step: "2",
                  label: "Contraseña del certificado",
                },
              }),
              _vm._v(" "),
              _c("b-step-item", {
                attrs: { clickable: false, step: "3", label: "Fin" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.step === 0
        ? _c("div", { staticClass: "box" }, [
            _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Inicio")]),
            _vm._v("\n    " + _vm._s(_vm.instrucciones) + "\n    "),
            _c("div", { staticClass: "buttons is-right mt-6" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  on: { click: _vm.nextStep },
                },
                [
                  _vm._v("\n        Continuar  \n        "),
                  _c("i", { staticClass: "fas fa-arrow-right fa-sm" }),
                ]
              ),
            ]),
          ])
        : _vm.step === 1
        ? _c(
            "div",
            { staticClass: "box" },
            [
              _c("h1", { staticClass: "subtitle is-5" }, [
                _vm._v("Contraseña del certificado"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4 mb-3" }, [
                _vm._v(
                  "Verifique sus datos de usuario. Si observa algún error, comuníquese con el administrador antes de continuar con la solicitud."
                ),
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "table is-bordered" }, [
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("Nombre")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.usuario.nombre))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Apellido")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.usuario.apellido))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("CUIL")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.usuario.cuil))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.usuario.email))]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-4 mb-2" }, [
                _vm._v("Ingrese una contraseña para proteger su certificado."),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Contraseña")]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:4|max:64",
                        expression: "'required|min:4|max:64'",
                      },
                    ],
                    ref: "password",
                    staticClass: "input",
                    attrs: {
                      type: "password",
                      name: "password",
                      required: "",
                      maxlength: "64",
                      "data-vv-scope": "passwords",
                      "data-vv-as": "Contraseña",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("password", "passwords")
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.errors.first("password", "passwords")) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Confirmar contraseña"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmedPassword,
                        expression: "confirmedPassword",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|confirmed:password",
                        expression: "'required|confirmed:password'",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "password",
                      name: "confirmedPassword",
                      required: "",
                      maxlength: "64",
                      "data-vv-scope": "passwords",
                      "data-vv-as": "Confirmar contraseña",
                    },
                    domProps: { value: _vm.confirmedPassword },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.confirmedPassword = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("confirmedPassword", "passwords")
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.errors.first("confirmedPassword", "passwords")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-notification",
                {
                  attrs: {
                    type: "is-warning is-light mt-5",
                    "has-icon": "",
                    closable: false,
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-info mr-4" }),
                  _vm._v(" "),
                  _c("b", [_vm._v("No debe olvidar su contraseña")]),
                  _vm._v(", se le será solicitada más adelante.\n    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-field",
                { staticClass: "mx-1" },
                [
                  _c(
                    "b-checkbox",
                    {
                      model: {
                        value: _vm.confirmConditions,
                        callback: function ($$v) {
                          _vm.confirmConditions = $$v
                        },
                        expression: "confirmConditions",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Comprendo que Signar almacenará mi archivo de certificado. A su vez, si cuento ya con uno cargado en la plataforma, comprendo que será reemplazado por el nuevo solicitado.\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons is-right mt-6" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "is-light mr-2",
                      on: { click: _vm.goBackStep0 },
                    },
                    [_vm._v("\n        Volver\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: !_vm.confirmConditions },
                      on: { click: _vm.createKeyPair },
                    },
                    [
                      _vm._v("\n        Continuar  \n        "),
                      _c("i", { staticClass: "fas fa-arrow-right fa-sm" }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.step === 2
        ? _c("div", { staticClass: "box" }, [
            _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Fin")]),
            _vm._v(" "),
            !_vm.error
              ? _c(
                  "div",
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "b-notification",
                      {
                        attrs: {
                          type: "is-warning is-light",
                          "has-icon": "",
                          closable: false,
                        },
                      },
                      [
                        _c("i", { staticClass: "fas fa-info mr-4" }),
                        _vm._v("\n        Recuerde imprimir el "),
                        _c("b", [_vm._v("Acuerdo de Suscriptores")]),
                        _vm._v(
                          ", firmarlo y acercarlo a la oficina correspondiente.\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "section has-text-centered" }, [
                  _c("i", {
                    staticClass:
                      "fas fa-times-circle has-text-danger fa-4x mb-4",
                  }),
                  _vm._v(" "),
                  _c("h1", { staticClass: "title is-4 has-text-danger" }, [
                    _vm._v("Error al registrar la solicitud"),
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "subtitle is-5 has-text-info" }, [
                    _vm._v(
                      "Puede reintentar el proceso o comuníquese con Soporte"
                    ),
                  ]),
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "buttons is-right mt-6" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "is-primary",
                    on: {
                      click: function ($event) {
                        return _vm.$router.replace({
                          name: "certificadosListado",
                        })
                      },
                    },
                  },
                  [_vm._v("\n        Volver a mis certificados\n      ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section has-text-centered" }, [
      _c("i", {
        staticClass: "fas fa-check-circle has-text-success fa-4x mb-4",
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-4 has-text-success" }, [
        _vm._v("Ha llegado al final del procedimiento"),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "subtitle is-5 has-text-success" }, [
        _vm._v("Su solicitud está pendiente de revisión"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }